module.exports = __webpack_public_path__ + "static/media/kerkom-logo.7b343c30.png";